import PhotoModalContent from './PhotoModalContent';

export default PhotoModalContent;
